import React, { FC } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  IconButton,
  styled,
} from "@mui/material";
import { Folder, Delete, Visibility, Download } from "@mui/icons-material";
import { defaultStyles, FileIcon } from "react-file-icon";
import { File } from "../model/File";
import { formatISODateString } from "../../../components/common/utils/DateUtils";

interface FileTableProps {
  files: File[];
  onOpenFolder: (name: string) => void;
  onViewFile: (file: File) => void;
  onDelete: (name: string) => void;
  onDownload: (name: string) => void;
}

const StyledFileIcon = styled(FileIcon)`
  width: 10px;
  height: 10px;
`;

const FileTable: FC<FileTableProps> = ({
  files,
  onOpenFolder,
  onViewFile,
  onDelete,
  onDownload,
}) => {
  const getDefaultStyles = (type: string | undefined) => {
    if (type && type in defaultStyles) {
      return defaultStyles[type as keyof typeof defaultStyles];
    }
    return defaultStyles.txt; // Provide a default style
  };
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Icon</TableCell>
            <TableCell>Name</TableCell>
            <TableCell>Type</TableCell>
            <TableCell>Size(In Bytes)</TableCell>
            <TableCell>Date</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {files &&
            Array.isArray(files) &&
            files.map((file) => (
              <TableRow key={file?.id}>
                <TableCell sx={{ width: "10px", height: "10px" }}>
                  {file?.type === "folder" ? (
                    <Folder />
                  ) : (
                    <StyledFileIcon
                      extension={file?.type}
                      {...getDefaultStyles(file?.type)}
                    />
                  )}
                </TableCell>
                <TableCell>
                  {file?.type === "folder" ? (
                    <Button onClick={() => onOpenFolder(file?.name)}>
                      {file?.name}
                    </Button>
                  ) : (
                    file?.name
                  )}
                </TableCell>
                <TableCell>{file?.type.toUpperCase()}</TableCell>
                <TableCell>{file?.size || "-"}</TableCell>
                <TableCell>
                  {formatISODateString(file?.date)}
                </TableCell>
                <TableCell>
                  {file?.type !== "folder" && (
                    <>
                      {/* <IconButton onClick={() => onViewFile(file)}>
                        <Visibility />
                      </IconButton> */}
                      <IconButton onClick={() => onDelete(file?.name)}>
                        <Delete />
                      </IconButton>
                      <IconButton onClick={() => onDownload(file?.name)}>
                        <Download />
                      </IconButton>
                    </>
                  )}
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default FileTable;
